import * as tslib_1 from "tslib";
import * as React from 'react';
export default function Toolbar(props) {
    var rootStyle = tslib_1.__assign({}, styles.root, props.style);
    return (React.createElement("div", tslib_1.__assign({}, props, { style: rootStyle })));
}
var styles = {
    root: {
        backgroundColor: '#f5f5f5',
        borderBottom: '1px solid #ddd',
    },
};
//# sourceMappingURL=Toolbar.js.map